import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { IFormBuilderQuestion } from '@g99-product-web-ui/shared-interface-lib';

import { RegexEnum } from '../regex/regex';
export const FORM_BUILDER_DEFAULT_QUESTION: IFormBuilderQuestion = {
  name: '',
  type: 'Input',
  required: false,
  answer: '',
  questionOrder: 0,
  id: 0,
  allowMultipleSelection: false,
  allowLabelsDisplayWithImages: false,
  mode: 'Edit',
  hidden: false,
  renderByWorkflow: false,
  enablePhoneAuthentication: null,
  validate: false,
  regex: '',
  validationMessage: '',
  showDropDown: false,
  preSelectCheckbox: false,
  description: '',
  subHeading: '',
  externalReferenceLink: '',
  tncFilelink: '',
  tncFileType: '',
  tncText: '',
  questionChoices: [],
  questionImages: [],
  createdAt: null,
  updatedAt: null,
  createdBy: null,
  updatedBy: null,
  deleted: null,
  tenantId: null,
  placeHolderText: null,
};

export enum FormBuilderInputTypeEnum {
  Input = 'Input',
  Text = 'Text',
  Yes_No = 'Yes_No',
  Date = 'Date',
  Multiple_Selection_Text = 'Multiple_Selection_Text',
  File = 'File',
  Phone_Number = 'Phone_Number',
}

export function patchQuestionFormBuilderChatbot(
  form: FormBuilder,
  question: any
): FormGroup {
  return form.group({
    name: [question.name, [Validators.required]],
    type: [question.type, [Validators.required]],
    required: [question.required],
    hidden: [question.hidden],
    renderByWorkflow: [question.renderByWorkflow ?? false],
    validate: [question.validate],
    enablePhoneAuthentication: [question.enablePhoneAuthentication],
    regex: [question.regex],
    questionOrder: [question.questionOrder],
    answer: [question.answer],
    id: [question.id],
    allowMultipleSelection: [question.allowMultipleSelection],
    allowLabelsDisplayWithImages: [question.allowLabelsDisplayWithImages],
    validationMessage: [question.validationMessage],
    subHeading: [question.subHeading],
    description: [question.description],
    externalReferenceLink: [
      question.externalReferenceLink,
      [Validators.pattern(RegexEnum.url)],
    ],
    tncFilelink: [question.tncFilelink],
    tncFileType: [question.tncFileType],
    tncText: [question.tncText],
    preSelectCheckbox: [question.preSelectCheckbox || false],
    showDropDown: [question.showDropDown || false],
    questionChoices: form.array([]), // Initialize the choices as a FormArray
    questionImages: form.array([]), // Initialize the images as a FormArray
  });
}
